import { defineMessages } from 'react-intl';

export default defineMessages({
  states: {
    id: 'ProgramInfo.states',
    defaultMessage: 'States',
  },
  zipCodes: {
    id: 'ProgramInfo.zipCodes',
    defaultMessage: 'ZIP Codes',
  },
  counties: {
    id: 'ProgramInfo.counties',
    defaultMessage: 'Counties',
  },
  cities: {
    id: 'ProgramInfo.cities',
    defaultMessage: 'Cities',
  },
  ages: {
    id: 'ProgramInfo.ages',
    defaultMessage: 'Ages',
  },
  genders: {
    id: 'ProgramInfo.genders',
    defaultMessage: 'Genders',
  },
  populations: {
    id: 'ProgramInfo.populations',
    defaultMessage: 'Populations',
  },
  programDelivery: {
    id: 'ProgramInfo.programDelivery',
    defaultMessage: 'Program Delivery',
  },
  supportedLanguages: {
    id: 'ProgramInfo.supportedLanguages',
    defaultMessage: 'Supported Languages',
  },
  populationsSpecialized: {
    id: 'ProgramInfo.populationsSpecialized',
    defaultMessage: 'Populations Specialized In',
  },
  agesSpecializedIn: {
    id: 'ProgramInfo.agesSpecializedIn',
    defaultMessage: 'Ages Specialized In',
  },
  accessibilityServices: {
    id: 'ProgramInfo.accessibilityServices',
    defaultMessage: 'Accessibility Services',
  },
  transportationOptions: {
    id: 'ProgramInfo.transportationOptions',
    defaultMessage: 'Transportation Options',
  },
  paymentOptions: {
    id: 'ProgramInfo.paymentOptions',
    defaultMessage: 'Payment Options',
  },
});

export const accOptionsMessages = defineMessages({
  adaAccessisble: {
    defaultMessage: 'ADA accessible',
    id: 'ada_accessible',
  },
  blindAccomodation: {
    defaultMessage: 'Blind accommodation',
    id: 'blind_accomodation',
  },
  deaf: {
    defaultMessage: 'Deaf or hard of hearing',
    id: 'deaf_or_hard_of_hearing',
  },
  translationServices: {
    defaultMessage: 'Interpreter/translation services available',
    id: 'translation_services',
  },
});

export const deliveryOptMessages = defineMessages({
  inHome: {
    defaultMessage: 'In Home',
    id: 'in_home',
  },
  inOffice: {
    defaultMessage: 'In Office',
    id: 'in_office',
  },
  webBased: {
    defaultMessage: 'Web Based',
    id: 'web_based',
  },
  phoneBased: {
    defaultMessage: 'Phone Based',
    id: 'phone_based',
  },
});

export const languageOptMessages = defineMessages({
  af: {
    defaultMessage: 'Afrikaans',
    id: 'af',
  },
  sq: {
    defaultMessage: 'Albanian',
    id: 'sq',
  },
  american_sign_language: {
    defaultMessage: 'American Sign Language',
    id: 'american_sign_language',
  },
  am: {
    defaultMessage: 'Amharic',
    id: 'am',
  },
  ar: {
    defaultMessage: 'Arabic',
    id: 'ar',
  },
  hy: {
    defaultMessage: 'Armenian',
    id: 'hy',
  },
  eu: {
    defaultMessage: 'Basque',
    id: 'eu',
  },
  bn: {
    defaultMessage: 'Bengali',
    id: 'bn',
  },
  bs: {
    defaultMessage: 'Bosnian',
    id: 'bs',
  },
  my: {
    defaultMessage: 'Burmese',
    id: 'my',
  },
  bg: {
    defaultMessage: 'Bulgarian',
    id: 'bg',
  },
  ca: {
    defaultMessage: 'Catalan',
    id: 'ca',
  },
  km: {
    defaultMessage: 'Central Khmer',
    id: 'km',
  },
  zh: {
    defaultMessage: 'Chinese',
    id: 'zh',
  },
  chk: {
    defaultMessage: 'Chuukese',
    id: 'chk',
  },
  hr: {
    defaultMessage: 'Croatian',
    id: 'hr',
  },
  cs: {
    defaultMessage: 'Czech',
    id: 'cs',
  },
  da: {
    defaultMessage: 'Danish',
    id: 'da',
  },
  prs: {
    defaultMessage: 'Dari',
    id: 'prs',
  },
  nl: {
    defaultMessage: 'Dutch',
    id: 'nl',
  },
  en: {
    defaultMessage: 'English',
    id: 'en',
  },
  et: {
    defaultMessage: 'Estonian',
    id: 'et',
  },
  fj: {
    defaultMessage: 'Fijian',
    id: 'fj',
  },
  fi: {
    defaultMessage: 'Finnish',
    id: 'fi',
  },
  fr: {
    defaultMessage: 'French',
    id: 'fr',
  },
  ka: {
    defaultMessage: 'Georgian',
    id: 'ka',
  },
  de: {
    defaultMessage: 'German',
    id: 'de',
  },
  gu: {
    defaultMessage: 'Gujarati',
    id: 'gu',
  },
  ht: {
    defaultMessage: 'Haitian Creole',
    id: 'ht',
  },
  haw: {
    defaultMessage: 'Hawaiian',
    id: 'haw',
  },
  he: {
    defaultMessage: 'Hebrew',
    id: 'he',
  },
  hi: {
    defaultMessage: 'Hindi',
    id: 'hi',
  },
  hmn: {
    defaultMessage: 'Hmong',
    id: 'hmn',
  },
  hu: {
    defaultMessage: 'Hungarian',
    id: 'hu',
  },
  is: {
    defaultMessage: 'Icelandic',
    id: 'is',
  },
  ilo: {
    defaultMessage: 'Ilocano',
    id: 'ilo',
  },
  id: {
    defaultMessage: 'Indonesian',
    id: 'id',
  },
  ga: {
    defaultMessage: 'Irish',
    id: 'ga',
  },
  it: {
    defaultMessage: 'Italian',
    id: 'it',
  },
  ja: {
    defaultMessage: 'Japanese',
    id: 'ja',
  },
  rw: {
    defaultMessage: 'Kinyarwanda',
    id: 'rw',
  },
  rn: {
    defaultMessage: 'Kirundi',
    id: 'rn',
  },
  ko: {
    defaultMessage: 'Korean',
    id: 'ko',
  },
  kos: {
    defaultMessage: 'Kosraean',
    id: 'kos',
  },
  lo: {
    defaultMessage: 'Lao',
    id: 'lo',
  },
  la: {
    defaultMessage: 'Latin',
    id: 'la',
  },
  lv: {
    defaultMessage: 'Latvian',
    id: 'lv',
  },
  lt: {
    defaultMessage: 'Lithuanian',
    id: 'lt',
  },
  ymm: {
    defaultMessage: 'Maay Maay',
    id: 'ymm',
  },
  mk: {
    defaultMessage: 'Macedonian',
    id: 'mk',
  },
  ms: {
    defaultMessage: 'Malay',
    id: 'ms',
  },
  ml: {
    defaultMessage: 'Malayalam',
    id: 'ml',
  },
  mt: {
    defaultMessage: 'Maltese',
    id: 'mt',
  },
  mi: {
    defaultMessage: 'Maori',
    id: 'mi',
  },
  mr: {
    defaultMessage: 'Marathi',
    id: 'mr',
  },
  mh: {
    defaultMessage: 'Marshallese',
    id: 'mh',
  },
  el: {
    defaultMessage: 'Modern Greek (1453-)',
    id: 'el',
  },
  mn: {
    defaultMessage: 'Mongolian',
    id: 'mn',
  },
  ne: {
    defaultMessage: 'Nepali',
    id: 'ne',
  },
  no: {
    defaultMessage: 'Norwegian',
    id: 'no',
  },
  om: {
    defaultMessage: 'Oromo',
    id: 'om',
  },
  pa: {
    defaultMessage: 'Punjabi',
    id: 'pa',
  },
  fa: {
    defaultMessage: 'Persian',
    id: 'fa',
  },
  pon: {
    defaultMessage: 'Pohnpeian',
    id: 'pon',
  },
  pl: {
    defaultMessage: 'Polish',
    id: 'pl',
  },
  pt: {
    defaultMessage: 'Portuguese',
    id: 'pt',
  },
  qu: {
    defaultMessage: 'Quechua',
    id: 'qu',
  },
  ro: {
    defaultMessage: 'Romanian',
    id: 'ro',
  },
  ru: {
    defaultMessage: 'Russian',
    id: 'ru',
  },
  sm: {
    defaultMessage: 'Samoan',
    id: 'sm',
  },
  sr: {
    defaultMessage: 'Serbian',
    id: 'sr',
  },
  sk: {
    defaultMessage: 'Slovak',
    id: 'sk',
  },
  sl: {
    defaultMessage: 'Slovenian',
    id: 'sl',
  },
  so: {
    defaultMessage: 'Somali',
    id: 'so',
  },
  es: {
    defaultMessage: 'Spanish',
    id: 'es',
  },
  sw: {
    defaultMessage: 'Swahili',
    id: 'sw',
  },
  sv: {
    defaultMessage: 'Swedish',
    id: 'sv',
  },
  tl: {
    defaultMessage: 'Tagalog',
    id: 'tl',
  },
  ta: {
    defaultMessage: 'Tamil',
    id: 'ta',
  },
  tt: {
    defaultMessage: 'Tatar',
    id: 'tt',
  },
  te: {
    defaultMessage: 'Telugu',
    id: 'te',
  },
  th: {
    defaultMessage: 'Thai',
    id: 'th',
  },
  bo: {
    defaultMessage: 'Tibetan',
    id: 'bo',
  },
  to: {
    defaultMessage: 'Tonga (Tonga Islands)',
    id: 'to',
  },
  tr: {
    defaultMessage: 'Turkish',
    id: 'tr',
  },
  uk: {
    defaultMessage: 'Ukrainian',
    id: 'uk',
  },
  ur: {
    defaultMessage: 'Urdu',
    id: 'ur',
  },
  uz: {
    defaultMessage: 'Uzbek',
    id: 'uz',
  },
  vi: {
    defaultMessage: 'Vietnamese',
    id: 'vi',
  },
  cy: {
    defaultMessage: 'Welsh',
    id: 'cy',
  },
  xh: {
    defaultMessage: 'Xhosa',
    id: 'xh',
  },
  yap: {
    defaultMessage: 'Yapese',
    id: 'yap',
  },
});

export const populationOptMessages = defineMessages(
  {
    blind_or_low_vision: {
      defaultMessage: 'Blind or low vision',
      id: 'blind_or_low_vision',
    },
    deaf: {
      defaultMessage: 'Deaf or hard of hearing',
      id: 'deaf_or_hard_of_hearing',
    },
    people_with_chronic_conditions: {
      defaultMessage: 'People with chronic health conditions',
      id: 'people_with_chronic_conditions',
    },
    people_with_learning_disabilities: {
      defaultMessage: 'People with learning disabilities',
      id: 'people_with_learning_disabilities',
    },
    caregivers: {
      defaultMessage: 'Caregivers (Non-paternal)',
      id: 'caregivers',
    },
    domestic_violence_survivors: {
      defaultMessage: 'Domestic violence survivors',
      id: 'domestic_violence_survivors',
    },
    homebound: {
      defaultMessage: 'Homebound',
      id: 'homebound',
    },
    homeless: {
      defaultMessage: 'Homeless',
      id: 'homeless',
    },
    immigrants_and_refugees: {
      defaultMessage: 'Immigrants and refugees',
      id: 'immigrants_and_refugees',
    },
    justice_involved: {
      defaultMessage: 'Justice-involved',
      id: 'justice_involved',
    },
    lgbtq_plus: {
      defaultMessage: 'LGBTQ+',
      id: 'lgbtq_plus',
    },
    low_income_individuals_and_households: {
      defaultMessage: 'Low-income individuals and households',
      id: 'low_income_individuals_and_households',
    },
    native_americans_or_alaska_natives: {
      defaultMessage: 'Native Americans or Alaska Natives',
      id: 'native_americans_or_alaska_natives',
    },
    people_with_cognitive_disabilities: {
      defaultMessage: 'People with cognitive disabilities',
      id: 'people_with_cognitive_disabilities',
    },
    people_with_developmental_disabilities: {
      defaultMessage: 'People with developmental disabilities',
      id: 'people_with_developmental_disabilities',
    },
    people_with_hiv_aids: {
      defaultMessage: 'People with HIV/AIDS',
      id: 'people_with_hiv_aids',
    },
    people_with_mental_health_issues: {
      defaultMessage: 'People with mental health issues',
      id: 'people_with_mental_health_issues',
    },
    people_with_physical_disabilities: {
      defaultMessage: 'People with physical disabilities',
      id: 'people_with_physical_disabilities',
    },
    people_with_substance_abuse_issues: {
      defaultMessage: 'People with substance use issues',
      id: 'people_with_substance_abuse_issues',
    },
    pregnancy: {
      defaultMessage: 'Pregnancy',
      id: 'pregnancy',
    },
    registered_sex_offenders: {
      defaultMessage: 'Registered sex offenders',
      id: 'registered_sex_offenders',
    },
    sexual_assault_survivors: {
      defaultMessage: 'Sexual assault survivors',
      id: 'sexual_assault_survivors',
    },
    seniors: {
      defaultMessage: 'Sexual assault survivors',
      id: 'sexual_assault_survivors',
    },
    veterans_and_military_families: {
      defaultMessage: 'Veterans and military families',
      id: 'veterans_and_military_families',
    },
    victims_of_natural_disaster: {
      defaultMessage: 'Victims of natural disaster',
      id: 'victims_of_natural_disaster',
    },
    victims_of_crime: {
      defaultMessage: 'Victims of crime',
      id: 'victims_of_crime',
    },
    unemployed: {
      defaultMessage: 'Unemployed',
      id: 'unemployed',
    },
  },
);

export const transportationOptMessages = defineMessages({
  free_transportation: {
    defaultMessage: 'Free transportation offered',
    id: 'free_transportation',
  },
});

export const paymentOptMessages = defineMessages({
  free: {
    defaultMessage: 'Free',
    id: 'free',
  },
  insurance: {
    defaultMessage: 'Insurance',
    id: 'insurance',
  },
  self_pay: {
    defaultMessage: 'Self-pay',
    id: 'self_pay',
  },
  sliding_scale: {
    defaultMessage: 'Sliding Scale',
    id: 'sliding_scale',
  },
});

export const translateOptions = (formatMessage) => (values, optMessages) => {
  const translatedValues = [];
  values.forEach((val) => {
    const message = Object.values(optMessages).find(({ id }) => id === val);
    if (message) translatedValues.push(formatMessage(message));
  });
  return translatedValues;
};
